<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <!-- 头 -->
    <div class="section-one">
      <img src="../../img/product-3/banner.jpg" />

      <div class="nav-bar">
        <div class="nav-bar_label">PRODUCTS AND TECHNOLOGY</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>产品与技术</span>排水产品系统
        </div>
        <!-- <img src="../../img/product-3/nav-top.png" c lass="product p-3" /> -->
      </div>

      <img src="../../img/product-3/title.png" class="v-c-title product-3-title" />
    </div>

    <!-- 产品信息 -->
    <div class="section-middle">
      <div class="item">
        <img
          src="../../img/product-3/info-left.jpg"
          alt="排水产品系统 应用场景"
          class="zoomable"
          @click="show3d = true"
        />
      </div>

      <div class="item">
        <img
          src="../../img/product-3/info-right.jpg"
          alt="排水产品系统 产品信息"
          class="zoomable"
          @click="show3d = true"
        />
      </div>
    </div>

    <!-- 3D 构建图入口 -->
    <div class="dr-cta">
      <button class="dr-cta__btn" @click="show3d = true">
        <span class="dr-cta__ico">3D</span>
        查看排水汇流三通构建图
      </button>
    </div>

    <Model3D
      v-model="show3d"
      model-key="drainage-tee"
      title="45° 汇流承插三通"
      subtitle="排水产品系统"
    />

    <!-- 尾 -->
    <div class="section-one">
      <img src="../../img/product-3/bg1.jpg" class="bg" />

      <div class="product-3-info">
        <img src="../../img/product-3/bg-info.png" class="" />
      </div>
    </div>

    <Footer />
  </div>

</template>

<script>
// import $ from 'jquery'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1,
      show3d: false
    }
  },
  components: {
    Nav,
    Footer,
    // 异步加载：three.js 只在用户真的打开 3D 构建图时才下载
    Model3D: () => import('../../components/viewer3d/Model3D.vue')
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.dr-cta {
  background: #0d1418;
  padding: 56px 20px 60px;
  text-align: center;
}
.dr-cta__btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  font-size: 17px;
  padding: 15px 34px;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.25s;
  &:hover { background: #0c8066; border-color: #0c8066; }
}
.dr-cta__ico {
  font-size: 12px;
  letter-spacing: 1px;
  border: 1px solid currentColor;
  border-radius: 2px;
  padding: 2px 6px;
}
</style>